import './App.css';

function App() {
  return (
    <div style={{ fontFamily: 'Arial, sans-serif', minHeight: '100vh', backgroundColor: '#f44336', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', color: 'white', padding: '20px' }}>
      <h1 style={{ fontSize: '3rem', margin: 0 }}>🚨 Encuentrameya</h1>
      <p style={{ fontSize: '1.5rem', marginTop: '20px' }}>Coming Soon... 🚀</p>
      <p style={{ fontSize: '1.1rem', marginTop: '10px', opacity: 0.8 }}>La revolución de los servicios de emergencia</p>
    </div>
  );
}

export default App;